// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1xRQb","rightAdornment":"Header_rightAdornment__2Gnu3"};